import { defineLocale } from "../../registry";

const editor = defineLocale({
  ru: {
    "editor.tabs.label": "Разделы Pick",
    "editor.tab.basics": "Basics",
    "editor.tab.places": "Places",
    "editor.tab.options": "Options",
    "editor.tab.media": "Media",
    "editor.tab.links": "Links",
    "editor.tab.publishing": "Publishing",
    "editor.tab.partnerTerms": "Partner & terms",
    "editor.tab.unsaved": "несохранённые изменения",
    "editor.header.unsaved": "Есть несохранённые изменения",
    "editor.header.readOnly": "Только чтение",
    "editor.header.untitled": "Без названия",
    "editor.notFound.back": "К каталогу",
    "editor.tab.placeholder": "Раздел «{name}» появится в следующих обновлениях",
  },
  en: {
    "editor.tabs.label": "Pick sections",
    "editor.tab.basics": "Basics",
    "editor.tab.places": "Places",
    "editor.tab.options": "Options",
    "editor.tab.media": "Media",
    "editor.tab.links": "Links",
    "editor.tab.publishing": "Publishing",
    "editor.tab.partnerTerms": "Partner & terms",
    "editor.tab.unsaved": "unsaved changes",
    "editor.header.unsaved": "Unsaved changes",
    "editor.header.readOnly": "Read-only",
    "editor.header.untitled": "Untitled",
    "editor.notFound.back": "Back to catalog",
    "editor.tab.placeholder": "The {name} section is coming in a later update",
  },
});

export default editor;
